module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules03-d04deeb871aa445aba3151d86a4046b0.gif";